<template>
  <c-dropdown in-nav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <c-header-nav-link>
        <!--        <div class="c-avatar">-->
        <!--          <img-->
        <!--            src="img/avatars/6.jpg"-->
        <!--            class="c-avatar-img "-->
        <!--          />-->
        <!--        </div>-->
        <c-icon name="cil-user" />
      </c-header-nav-link>
    </template>
<!--    <c-dropdown-header tag="div" class="text-center" color="light">-->
<!--      <strong>Account</strong>-->
<!--    </c-dropdown-header>-->
<!--    <c-dropdown-item>-->
<!--      <c-icon name="cil-bell" />-->
<!--      Updates-->
<!--      <c-badge color="info" class="ml-auto">{{ itemsCount }}</c-badge>-->
<!--    </c-dropdown-item>-->
<!--    <c-dropdown-item>-->
<!--      <c-icon name="cil-envelope-open" />-->
<!--      Messages-->
<!--      <c-badge color="success" class="ml-auto">{{ itemsCount }}</c-badge>-->
<!--    </c-dropdown-item>-->
<!--    <c-dropdown-item>-->
<!--      <c-icon name="cil-task" />-->
<!--      Tasks-->
<!--      <c-badge color="danger" class="ml-auto">{{ itemsCount }}</c-badge>-->
<!--    </c-dropdown-item>-->
    <!--    <CDropdownItem>-->
    <!--      <CIcon name="cil-comment-square" /> Comments-->
    <!--      <CBadge color="warning" class="ml-auto">{{ itemsCount }}</CBadge>-->
    <!--    </CDropdownItem>-->
    <c-dropdown-header tag="div" class="text-center" color="light">
      <strong>Settings</strong>
    </c-dropdown-header>
    <c-dropdown-item>
      <c-icon name="cil-user" />
      <router-link to="/my-account">
        {{ $store.state.app.authenticatedUser.firstName }} {{ $store.state.app.authenticatedUser.lastName }}
      </router-link>
    </c-dropdown-item>
    <c-dropdown-item>
      <c-icon name="cil-settings" />
      <router-link to="/my-organisation">{{ $store.state.app.authenticatedUser.organisation.name }}</router-link>
    </c-dropdown-item>
    <!--    <CDropdownItem>-->
    <!--      <CIcon name="cil-dollar" /> Payments-->
    <!--      <CBadge color="secondary" class="ml-auto">{{ itemsCount }}</CBadge>-->
    <!--    </CDropdownItem>-->
    <!--    <CDropdownItem>-->
    <!--      <CIcon name="cil-file" /> Projects-->
    <!--      <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge>-->
    <!--    </CDropdownItem>-->
    <c-dropdown-divider />
    <!--    <CDropdownItem>-->
    <!--      <CIcon name="cil-shield-alt" /> Lock Account-->
    <!--    </CDropdownItem>-->
    <c-dropdown-item @click="logout">
      <c-icon name="cil-lock-locked" />
      Logout
    </c-dropdown-item>
  </c-dropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data() {
    return {
      itemsCount: 42,
    };
  },
  methods: {
    logout() {
      // this.showModal = false
      this.$auth.logout({
        redirect: '/login',
        makeRequest: false,
        success() {},
        // error: function () {},
        // etc...
      });
    },
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
